<template>
  <div style="height:100%">
    <BaseContainer style="height:100%" class="one_table">
      <TableMain name="one table" ref="TestTable2" :fields="fields" :title="table_title.title1"
        :show_query_container="true" :show_toolbar_container="true" :show_pagination_container="true"
        :show_date_picker="false" :show_toolbar="true" :show_filter="true" :date_picker_label="date_picker_label"
        :query_button_label="query_lable" :hb_table_class="'hb_table_sotracking_class'" :loading_width="55"
        :show_so_return="true" :isBusy="isBusy" @on_query="on_query" @state_change="state_change"
        :show_toolbar_button="[0, 0, 0, 0, 0]" @tool_invoke="tool_invoke" @current_changed="current_changed">
        <template #query>
          <el-select v-model="dateChoose" placeholder="" size="small" style="width: 100px">
            <el-option :label="$t('common.delivery_date')" value="date1"></el-option>
            <el-option :label="$t('common.order_date')" value="date2"></el-option>
          </el-select>
          <el-date-picker class="ml-2" size="small" style="width: 220px" v-model="date_range" type="daterange"
            align="right" unlink-panels range-separator="-" start-placeholder="" end-placeholder=""
            :picker-options="pickerOptions()">
          </el-date-picker>
          <el-input style="width: 300px" size="small" placeholder="" v-model="SalesId" class="input-with-select ml-2">
            <el-select v-model="SalesIdType" slot="prepend" :placeholder="$t('common.action_select')"
              style="width: 120px">
              <el-option :label="$t('common.plantform_order_num')" value="1"></el-option>
              <el-option :label="$t('common.ax_order_num')" value="2"></el-option>
            </el-select>
          </el-input>
          <!-- 订单编号：<el-input
            size="small"
            style="width: 120px"
            v-model="SalesId"
          ></el-input> -->
          {{ $t("common.invent") + $t("common.num") }}：<el-input clearable size="small" style="width: 120px"
            v-model="ItemId"></el-input>
          {{ $t("common.create_username") }}：<el-input clearable size="small" style="width: 120px"
            v-model="order_user"></el-input>
        </template>
        <template #toolbar>
          <el-tooltip content="数据同步" placement="top" effect="light">
            <el-button type="info" plain style="width: 55px" class="ml-2" @click="InvokeData"><i
                class="iconfont icon-refresh"></i></el-button>
          </el-tooltip>
        </template>
      </TableMain>
    </BaseContainer>
    <!-- 新增修改 -->
    <BaseModal ref="bvModal" :title="modal_title" @saveData="saveData">
      <template #modal_content>

        <el-row v-for="(item, index) in dataFormList" :key="index">
          <el-form :model="item" :rules="rules" ref="dataForm" label-width="100px" class="demo-dataForm">
            <el-col :span="5">
              <el-form-item :label="$t('common.num')">
                {{ item.dispatchId }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('common.so_return_description')" prop="return_qty">
                <el-input v-model="item.return_qty"
                  @input="item.return_qty = item.return_qty.replace(/-[^0-9.]/g, '')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item :label="$t('common.description')" prop="return_description">
                <el-input type="textarea" v-model="item.return_description" rows="1"></el-input>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>

      </template>
    </BaseModal>
  </div>
</template>

<script>
// -- import * as _ from "lodash-es"
import * as CustTableController from "../../controllers/base/CustTableController"
import * as SOTrackingController from "../../controllers/sd/SOTrackingController"
import BaseContainer from "../components/BaseContainer"
import TestQueryPanel from "../components/base/TestQueryPanel"
import BaseModal from "../components/modals/baseModal"
import TableMain from "../components/table/TableMain"

export default {
  name: "SOTracking",
  components: {
    BaseContainer,
    TableMain,
    BaseModal,
    TestQueryPanel,
  },
  data() {
    return {
      date_picker_label: "common.search",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "table_so_tracking",
      },
      modal_title: "create_so_return",
      fields: SOTrackingController.fields,
      dataForm: _.cloneDeep(SOTrackingController.dataForm),
      dataFormList: [],
      rules: SOTrackingController.rules,
      SalesId: "", //销售订单编号
      ItemId: "", //物料编号
      isBusy: false,
      tab_index: 0,
      date_range: "",
      order_user: "",
      dateChoose: "date2",
      SalesIdType: "1",
    }
  },
  created() { },
  mounted() {
    const end = new Date()
    const start = new Date()
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
    this.date_range = [start, end]
  },
  methods: {
    async InvokeData() {
      // this.isBusy_table1 = true;
      // this.$refs.CustTable1.SetData([]);
      const loading = this.$loading({
        lock: true,
        text: this.$t("notify.in_async"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })

      let _is_wait = true
      setTimeout(() => {
        if (_is_wait) {
          this.msgToasts(this.$t("notify.async_timeout"), "info")
          loading.close()
          _is_wait = false
        }
        return
      }, 30000)

      let _params = {
        company: "070",
        tableName: "secp_SalesLineReturn",
        accountNum: "", //不传则查询所有
      }
      await CustTableController.methods.pickAndInvoke(_params)

      loading.close()
      if (_is_wait) {
        this.msgToasts(this.$t("notify.async_success"), "success")
        _is_wait = false
      }
    },
    pickerOptions() {
      let this_ = this
      return {
        shortcuts: [
          {
            text: "最近7天",
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit("pick", [start, end])
            },
          },
          {
            text: "最近30天",
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit("pick", [start, end])
            },
          },
          {
            text: "最近90天",
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit("pick", [start, end])
            },
          },
        ],
      }
    },
    //#region 查询
    async on_query(set_data, date_range) {
      this.isBusy = true
      let _params = {}
      if (this.dateChoose == "date1") {
        if (!_.isNull(this.date_range) && this.SalesId == "") {
          let _fromDate = this.$date.format(this.date_range[0], "yyyy-MM-dd")
          let _toDate = this.$date.format(this.date_range[1], "yyyy-MM-dd")
          _toDate = this.$date.format(
            this.$date.addDays(new Date(_toDate), 1),
            "yyyy-MM-dd"
          )
          _params.FromDate = _fromDate
          _params.ToDate = _toDate
        }
      } else {
        if (!_.isNull(this.date_range) && this.SalesId == "") {
          let _fromOrderDate = this.$date.format(
            this.date_range[0],
            "yyyy-MM-dd"
          )
          let _toOrderDate = this.$date.format(
            this.date_range[1],
            "yyyy-MM-dd"
          )
          _toOrderDate = this.$date.format(
            this.$date.addDays(new Date(_toOrderDate), 1),
            "yyyy-MM-dd"
          )
          _params.FromOrderDate = _fromOrderDate
          _params.ToOrderDate = _toOrderDate
        }
      }
      if (this.SalesId != "" && this.SalesIdType == "1") {
        _params.SalesId = this.SalesId
      }
      if (this.SalesId != "" && this.SalesIdType == "2") {
        _params.AXSalesId = this.SalesId
      }
      if (this.ItemId != "") {
        _params.ItemId = this.ItemId
      }
      if (this.order_user != "") {
        _params.order_user = this.order_user
      }
      if (this.order_user != "" || this.ItemId != "" || this.SalesId != "") {
        if (_params.FromDate) {
          delete _params.FromDate
        }
        if (_params.ToDate) {
          delete _params.ToDate
        }
        if (_params.FromOrderDate) {
          delete _params.FromOrderDate
        }
        if (_params.ToOrderDate) {
          delete _params.ToOrderDate
        }
      }
      set_data([])
      let _result = await SOTrackingController.methods.getData(_params)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        _.each(_result[0], (t) => {
          if (t.SalesStatus == "已取消") {
            t.SalesFinancial = 0
            t.DeliveryQty = 0
          }
        })
        set_data(_result[0])
      }
      this.isBusy = false
    },
    //#endregion

    //#region 保存

    ///新增修改
    async saveData(cb) {
      let msg = ""
      _.each(this.dataFormList, (t) => {
        if (parseFloat(t.return_qty) == 0) {
          msg = this.$t("notify.so_return_qty_not_null")
        } else if (parseFloat(t.return_qty) > 0) {
          msg = this.$t("notify.so_return_qty_must_be_minus_number")
        } else if (_.isEmpty(t.return_description)) {
          msg = this.$t("notify.so_return_description_not_null")
        }
      })
      if (msg != "") {
        this.msgToasts(msg, "info")
        cb(null)
        return
      }
      ///保存数据
      let PList = []
      _.each(this.dataFormList, (t) => {
        PList.push({
          dispatchId: t.dispatchId,
          SalesQty: parseFloat(t.return_qty),
          TEC_CommonRemark: t.return_description,
          user_id: this.$store.state.biz_data.userInfo.user_id,
        })
      })
      let _result = await SOTrackingController.methods.saveRetrunSO(PList)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let is_ok = true
        let error_list = []
        for (var i in _result[0].Result.Data) {
          let t = _result[0].Result.Data[i]
          if (t[0].status != 0) {
            is_ok = false
            error_list.push(t[0].CanReturnQty)
          }
        }

        if (is_ok) {
          cb(true, true)
          this.dataFormList = []
        }
        else {
          this.msgToasts(
            this.$t("notify.so_return_qty_must_be_min_invoice_qty") + "：" +
            _.join(error_list, "，"),
            "info"
          )
          cb(null)
        }
        // if (_result[0].Result.Data[0][0].status == 0) {
        //   cb(true, true);
        //   this.dataForm.return_qty = 0;
        //   this.dataForm.return_description = "";
        // } else {
        //   let _can_return = parseFloat(
        //     _result[0].Result.Data[0][0].CanReturnQty
        //   );
        //   this.msgToasts(
        //     "保存失败！累计退货数量不能超过开票数量！当前允许退货数量：" +
        //     _can_return,
        //     "info"
        //   );
        //   cb(null);
        // }
      } else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "info")
        cb(null)
      }
    },
    //#endregion

    //#region 状态切换
    state_change(data, cb) {

      if (data.selected_items.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info")
        cb(false)
        return
      }
      if (data.state == "so_return") {
        // if (data.selected_items.length > 1) {
        //   this.msgToasts("不能同时操作多个退货！", "info");
        //   cb(false);
        //   return;
        // }
        this.dataFormList = []
        let is_check_ok = true
        _.each(data.selected_items, (t) => {
          let _return_dt = _.cloneDeep(t)
          if (parseFloat(_return_dt.SalesFinancial) <= 0) {
            is_check_ok = false
          }
          console.log(_return_dt.CanReturnQty)
          let _CanReturnQty = parseFloat(_return_dt.SalesFinancial) * -1
          if (!_.isNull(_return_dt.CanReturnQty)) {
            _CanReturnQty = parseFloat(_return_dt.CanReturnQty) * -1
          }
          let m = _.cloneDeep(this.dataForm)
          m.return_qty = _CanReturnQty
          m.dispatchId = _return_dt.id

          this.dataFormList.push(m)
        })
        if (!is_check_ok) {
          this.msgToasts(this.$t("notify.uninvoiced_not_return"), "info")
          cb(false)
          return
        }

        this.$refs.bvModal.show()
      }
    },
    //#endregion

    //#region 打印导出
    // tool_invoke(data, cb) {

    // },
    //#endregion

    current_changed(old, current) {

      this.$emit("current_changed", old, current)
    },
  },
}
</script>
<style>
.hb_table_sotracking_class {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 240rem;
}
</style>
